import type { components } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type SignUpRequest = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  body: {
    user: {
      email: string;
      first_name: string;
      join_community_id?: string;
      last_name: string;
      password: string;
      password_confirmation: string;
      recaptcha_token?: string;
      time_zone: string;
    };
  };
  params?: {
    invitation_token?: string;
    organization_id?: string;
  };
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

export const signUp = async ({ body, params }: SignUpRequest) =>
  apiClient.post<components['schemas']['UserDetail'], ApiClientResponse<components['schemas']['UserDetail']>>(
    routes.signup,
    body,
    {
      params,
      skipAuth: true,
    },
  );
